import { useEffect, useState } from 'react';
import { getValoresAfiliacion, putValoresAfiliacion } from '../../../services/adminService';
import theme from '../adminTheme';
import AdminSpinner from '../components/AdminSpinner';
import { useToast } from '../context/ToastContext';

const KEYS_AFILIACION = ['subjunior_club', 'subjunior_sin_club', 'junior_club', 'junior_sin_club', 'open_club', 'open_sin_club'];

const LABELS = {
  subjunior_club: 'SubJunior (<20 años) con club',
  subjunior_sin_club: 'SubJunior (<20 años) sin club',
  junior_club: 'Junior (20 a <24 años) con club',
  junior_sin_club: 'Junior (20 a <24 años) sin club',
  open_club: 'Open (24+ años) con club',
  open_sin_club: 'Open (24+ años) sin club'
};

const ValoresAfiliacionView = () => {
  const [data, setData] = useState(null);
  const [form, setForm] = useState({
    subjunior_club: '',
    subjunior_sin_club: '',
    junior_club: '',
    junior_sin_club: '',
    open_club: '',
    open_sin_club: ''
  });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const { showToast } = useToast();

  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const res = await getValoresAfiliacion();
      const d = res.data || res;
      setData(d);
      setForm({
        subjunior_club: String(d.subjunior_club ?? ''),
        subjunior_sin_club: String(d.subjunior_sin_club ?? ''),
        junior_club: String(d.junior_club ?? ''),
        junior_sin_club: String(d.junior_sin_club ?? ''),
        open_club: String(d.open_club ?? ''),
        open_sin_club: String(d.open_sin_club ?? '')
      });
    } catch (e) {
      setError(e.message || 'Error al cargar valores');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const handleChange = (key, value) => {
    setForm(prev => ({ ...prev, [key]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const payload = {};
    KEYS_AFILIACION.forEach(k => { payload[k] = parseInt(form[k], 10); });
    if (KEYS_AFILIACION.some(k => payload[k] < 0)) {
      showToast('Los montos deben ser mayores o iguales a 0', 'error');
      return;
    }
    setSaving(true);
    try {
      const res = await putValoresAfiliacion(payload);
      setData(res.data || res);
      const next = {};
      KEYS_AFILIACION.forEach(k => { next[k] = String(res.data?.[k] ?? form[k]); });
      setForm(next);
      showToast('Valores guardados correctamente', 'success');
    } catch (e) {
      showToast(e.message || 'Error al guardar', 'error');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={theme.container}>
        <AdminSpinner />
      </div>
    );
  }

  return (
    <div style={theme.container}>
      <div style={theme.pageHeader}>
        <h2 style={theme.title}>Valores de afiliación</h2>
        <p style={{ color: '#6b7280', marginTop: 4 }}>
          Montos en {data?.moneda || 'CLP'} según categoría (SubJunior/Junior/Open y con/sin club). SubJunior {'<'}20 años, Junior 20-{'<'}24, Open 24+. Se usan al procesar el pago de afiliación.
        </p>
      </div>

      {error && (
        <div style={{ padding: 12, background: '#fef2f2', color: '#b91c1c', borderRadius: 8, marginBottom: 16 }}>
          {error}
        </div>
      )}

      <form onSubmit={handleSubmit} style={{ maxWidth: 480 }}>
        {KEYS_AFILIACION.map(key => (
          <div key={key} style={{ marginBottom: 16 }}>
            <label style={{ display: 'block', fontWeight: 600, marginBottom: 4 }}>{LABELS[key]}</label>
            <input
              type="number"
              min={0}
              value={form[key]}
              onChange={e => handleChange(key, e.target.value)}
              style={{
                width: '100%',
                padding: '8px 12px',
                border: '1px solid #d1d5db',
                borderRadius: 6,
                fontSize: 16
              }}
            />
            <span style={{ marginLeft: 8, color: '#6b7280' }}>{data?.moneda || 'CLP'}</span>
          </div>
        ))}
        <button
          type="submit"
          disabled={saving}
          style={{
            padding: '10px 20px',
            background: theme.primary?.background || '#1a4d8c',
            color: '#fff',
            border: 'none',
            borderRadius: 6,
            fontWeight: 600,
            cursor: saving ? 'not-allowed' : 'pointer'
          }}
        >
          {saving ? 'Guardando…' : 'Guardar valores'}
        </button>
      </form>
    </div>
  );
};

export default ValoresAfiliacionView;
